// import {
//   Accordion,
//   AccordionDetails,
//   AccordionSummary,
//   Box,
//   IconButton,
//   Typography,
// } from "@mui/material";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { GridSortItem } from "@mui/x-data-grid";
import { useState } from "react";
import { useParams } from "react-router-dom";
// import ActionMenu from "../../../../../../../../components/app/ActionMenu";
import DeleteModal from "../../../../../../../../components/app/DeleteModal";
import CustomDataGridV2 from "../../../../../../../../components/CustomDataGridV2";
import { useRoleController } from "../../../../../../../../components/useRoleController";
import { useArchiveState } from "../../../../../../../../hooks/useArchiveState";
import { useArchiveVital } from "../../../../../../../../queries/vitals/use-patient-vital-archive";
import { usePatientVitalsList } from "../../../../../../../../queries/vitals/use-patient-vitals-list";
import { formatDateTime } from "../../../../../../../../utils/date-time-utility";
import {
  applyDefaultColumnSettings,
  DEF_PAGINATION,
  DGT_Pagination,
  filterActionCol,
  getXtenantId,
} from "../../../../../../../../utils/utils";

interface VitalsListProps {
  isInsideVisitNote?: boolean;
}

const VitalsList = ({ isInsideVisitNote = false }: VitalsListProps) => {
  const [pagination, setPagination] = useState<DGT_Pagination>(DEF_PAGINATION);
  const [gridSorting, setGridSorting] = useState<GridSortItem[]>([]);
  const { patientId } = useParams() as { patientId: any };
  const { mutateAsync: archiveVital } = useArchiveVital();
  const { archiveHandler, deleteDisc } = useArchiveState(archiveVital);
  const {
    //  hasDelete,
    hasReadOnly,
  } = useRoleController("Clinical");

  const { data: vitalsList, refetch } = usePatientVitalsList({
    patientUuid: patientId,
    pagination,
    gridSorting,
    archive: false,
    xTENANTID: getXtenantId() ?? undefined,
  });

  const COLUMNS = applyDefaultColumnSettings<any>(
    [
      {
        field: "recordedDate",
        headerName: "Recorded At",
        flex: 0.55,
        renderCell: ({ value }) => (value ? formatDateTime(value) : "-"),
      },
      {
        field: "createdBy",
        headerName: "Recorded By",
        flex: 0.55,
        renderCell: ({ value }) => value ?? "-",
      },
      {
        field: "bodyTemperature",
        headerName: "Temp.",
        flex: 0.4,
        renderCell: ({ value, row }) =>
          value === null || value === undefined
            ? "-"
            : `${value} ${row?.bodyTemperatureUnit === "c" ? "°C" : "°F"}`,
      },
      {
        field: "heartRate",
        headerName: "Heart Rate (bpm)",
        flex: 0.55,
        renderCell: ({ value }) => value ?? "-",
      },
      {
        field: "bloodPressure",
        headerName: "B.P. (mmhg)",
        flex: 0.45,
        renderCell: ({ row }) =>
          (row?.systolic ?? row?.diastolic ?? null) === null
            ? "-"
            : `${row?.systolic ?? "-"}/${row?.diastolic ?? "-"}`,
      },
      {
        field: "respirationRate",
        headerName: "Resp. Rate (bpm)",
        flex: 0.55,
        renderCell: ({ value }) => value ?? "-",
      },
      {
        field: "o2Saturation",
        headerName: "O₂ Saturation (%)",
        flex: 0.6,
        renderCell: ({ value }) => value ?? "-",
      },
      {
        field: "bmi",
        headerName: "BMI (Kg/m²)",
        flex: 0.45,
        renderCell: ({ value }) => value ?? "-",
      },
      {
        field: "weight",
        headerName: "Weight",
        flex: 0.35,
        renderCell: ({ row }) => row?.weight ?? "-",
      },
      // {
      //   field: "height",
      //   headerName: "Height",
      //   flex: 0.3,
      //   renderCell: ({ row }) =>
      //     row?.height != null ? `${row.height} ${row?.heightUnit ?? ""}` : "-",
      // },
      {
        field: "bloodGlucose",
        headerName: "Blood Glucose(mg/dl)",
        flex: 0.7,
        renderCell: ({ value }) => value ?? "-",
      },
      // {
      //   field: "perfusionIndex",
      //   headerName: "Perf. Index",
      //   flex: 0.3,
      //   renderCell: ({ row }) =>
      //     row?.perfusionIndex != null
      //       ? `${row.perfusionIndex}${row?.perfusionIndexUnit ?? "%"}`
      //       : "-",
      // },
      // {
      //   field: "Action",
      //   width: 70,
      //   align: "center",
      //   headerAlign: "center",
      //   hideSortIcons: true,
      //   renderCell: ({ row }) => {
      //     return (
      //       <ActionMenu
      //         options={roleFilter({
      //           list: [
      //             // { value: "edit", label: "Edit" },
      //             { value: "delete", label: "Delete" },
      //           ],
      //           compWith: {
      //             // edit: hasUpdate,
      //             delete: hasDelete,
      //           },
      //         })}
      //         onActionClick={(v) => {
      //           if (v === "delete") deleteDisc.open(row?.uuid);
      //         }}
      //       />
      //     );
      //   },
      // },
    ],
    ["recordedDate"]
  );

  // const vitalsRows = vitalsList?.data?.content ?? [];
  //
  // const getVitalItems = (row: any) => {
  //   const items: { label: string; value: string; unit: string }[] = [];
  //   if (row?.bodyTemperature != null)
  //     items.push({
  //       label: "Temperature",
  //       value: String(row.bodyTemperature),
  //       unit: `\u00b0C`,
  //     });
  //   if (row?.o2Saturation != null)
  //     items.push({
  //       label: "Oxygen Saturation",
  //       value: String(row.o2Saturation),
  //       unit: "%",
  //     });
  //   if (row?.heartRate != null)
  //     items.push({
  //       label: "Heart Rate",
  //       value: String(row.heartRate),
  //       unit: "bpm",
  //     });
  //   if (row?.systolic != null || row?.diastolic != null)
  //     items.push({
  //       label: "Blood Pressure",
  //       value: `${row?.systolic ?? ""} / ${row?.diastolic ?? ""}`,
  //       unit: "mmhg",
  //     });
  //   if (row?.respirationRate != null)
  //     items.push({
  //       label: "Respiration Rate",
  //       value: String(row.respirationRate),
  //       unit: "bpm",
  //     });
  //   if (row?.weight != null)
  //     items.push({ label: "Weight", value: String(row.weight), unit: "Kg" });
  //   if (row?.bmi != null)
  //     items.push({ label: "BMI", value: String(row.bmi), unit: "Kg/m\u00b2" });
  //   if (row?.bloodGlucose != null)
  //     items.push({
  //       label: "Blood Glucose",
  //       value: String(row.bloodGlucose),
  //       unit: "mg/dL",
  //     });
  //   return items;
  // };

  return (
    <>
      <DeleteModal
        w="380px"
        open={deleteDisc.opened}
        onClose={deleteDisc.close}
        id={deleteDisc.deleteId}
        onConfirmation={async (id) => {
          const res = await archiveHandler(true, id);
          await refetch();
          return res;
        }}
        content={"You want to delete this vital"}
      />

      {/* <ChartTableWrapper> */}
      <CustomDataGridV2
        getRowId={(row) => row?.uuid}
        rows={vitalsList?.data?.content ?? []}
        rowCount={vitalsList?.data?.page?.totalElements ?? 10}
        columns={filterActionCol(COLUMNS, hasReadOnly || isInsideVisitNote)}
        disableRowSelectionOnClick
        paginationModel={pagination}
        onPaginationModelChange={setPagination}
        onSortModelChange={setGridSorting}
      />

      {/* 
        <Box
          sx={{
            marginTop: "20px",
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          {vitalsRows.map((row: any) => (
            <Accordion
              key={row?.uuid}
              disableGutters
              elevation={0}
              sx={{
                border: "1px solid #e0e0e0",
                borderLeft: "3px solid #1976d2",
                borderRadius: "4px !important",
                "&:before": { display: "none" },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                  px: 2,
                  "& .MuiAccordionSummary-content": {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    my: 1,
                  },
                }}
              >
                <Box>
                  <Typography fontWeight={600} fontSize={14}>
                    {NonNullableDate(row?.recordedDate)}
                  </Typography>
                  <Typography fontSize={13} color="text.secondary">
                    {row?.createdBy
                      ? replaceUnderScoreAddSpace(row.createdBy.toLowerCase())
                      : "-"}
                  </Typography>
                </Box>
                {!isInsideVisitNote && (
                  <Box
                    sx={{ display: "flex", gap: 0.5 }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <IconButton
                      size="small"
                      onClick={() => deleteDisc.open(row?.uuid)}
                    >
                      <DeleteOutlineIcon
                        fontSize="small"
                        sx={{ color: "error.main" }}
                      />
                    </IconButton>
                  </Box>
                )}
              </AccordionSummary>
              <AccordionDetails sx={{ px: 2, pt: 0, pb: 2 }}>
                {getVitalItems(row).map((item, idx) => (
                  <Box
                    key={idx}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      py: 1.2,
                      borderBottom:
                        idx < getVitalItems(row).length - 1
                          ? "1px solid #f0f0f0"
                          : "none",
                    }}
                  >
                    <Typography fontSize={14}>{item.label}</Typography>
                    <Typography fontSize={14} fontWeight={500}>
                      {item.value}{" "}
                      <Typography
                        component="span"
                        fontSize={13}
                        color="text.secondary"
                      >
                        {item.unit}
                      </Typography>
                    </Typography>
                  </Box>
                ))}
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
 */}
      {/* </ChartTableWrapper> */}
    </>
  );
};

export default VitalsList;
